module.exports = __webpack_public_path__ + "static/media/plus.0270a0ab.svg";